import { http } from '@/http/axios.js'
import axios from 'axios'
import { getToken } from '@/utils/auth'
import { showScreenLoading, hideScreenLoading } from '@/http/loading.js'
import { dateFormat } from '@/utils/index.js'

// 分账记录 - 分页列表
export function getZstRoyaltyListAPI(params) {
  return http({
    url: '/admin/alipay/zst/royalty/log/page',
    method: 'get',
    params
  })
}

// 分账记录 - 导出
export function exportZstRoyaltyAPI(data) {
  showScreenLoading()
  axios({
    method: 'post',
    url: '/api/admin/alipay/zst/royalty/log/export',
    responseType: 'blob',
    data,
    headers: {
      Authorization: getToken() || ''
    }
  })
    .then(async res => {
      hideScreenLoading()
      let data = res.data
      let url = window.URL.createObjectURL(new Blob([data]))
      let a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      let filename = `资商通分账记录${dateFormat()}.xlsx`
      a.setAttribute('download', decodeURIComponent(filename))
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(a.href)
      document.body.removeChild(a)
    })
    .catch(error => {
      hideScreenLoading()
      console.log(error)
    })
}
